/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { CustomerDtoGenericApiResponseFromJSON, CustomerDtoSortedPagedListResponseGenericApiResponseFromJSON, CustomerRequestToJSON, Int32GenericApiResponseFromJSON, SuccessfullApiResponseFromJSON, } from '../models';
/**
 *
 */
export class CustomerApi extends runtime.BaseAPI {
    /**
     */
    apiCustomerAddPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Customer/Add`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CustomerRequestToJSON(requestParameters.customerRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => Int32GenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCustomerAddPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCustomerAddPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCustomerDeleteIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiCustomerDeleteIdDelete.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Customer/Delete/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCustomerDeleteIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCustomerDeleteIdDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCustomerFindByGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.filtersSearchText !== undefined) {
                queryParameters['Filters.SearchText'] = requestParameters.filtersSearchText;
            }
            if (requestParameters.filtersNameAndSurname !== undefined) {
                queryParameters['Filters.NameAndSurname'] = requestParameters.filtersNameAndSurname;
            }
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Customer/FindBy`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CustomerDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCustomerFindByGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCustomerFindByGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCustomerGetAllGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.pageNumber !== undefined) {
                queryParameters['PageNumber'] = requestParameters.pageNumber;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['PageSize'] = requestParameters.pageSize;
            }
            if (requestParameters.sortPropertyName !== undefined) {
                queryParameters['SortPropertyName'] = requestParameters.sortPropertyName;
            }
            if (requestParameters.sortDirection !== undefined) {
                queryParameters['SortDirection'] = requestParameters.sortDirection;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Customer/GetAll`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CustomerDtoSortedPagedListResponseGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCustomerGetAllGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCustomerGetAllGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCustomerGetIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling apiCustomerGetIdGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Customer/Get/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CustomerDtoGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCustomerGetIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCustomerGetIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiCustomerUpdatePutRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/Customer/Update`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CustomerRequestToJSON(requestParameters.customerRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SuccessfullApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiCustomerUpdatePut(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiCustomerUpdatePutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
